var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1867_103593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.552 10.1719L23.9155 6.69674L20.7232 5.27662L19.3036 2.08434L15.8285 2.4473L12.9997 0.397461L10.1714 2.4473L6.69674 2.08434L5.27662 5.2761L2.08434 6.69674L2.4473 10.1714L0.397461 12.9997L2.4473 15.8274L2.08382 19.3026L5.2761 20.7227L6.6957 23.915L10.1709 23.552L12.9997 25.6019L15.8279 23.552L19.3026 23.915L20.7227 20.7232L23.915 19.3026L23.552 15.8279L25.6019 12.9997L23.552 10.1719ZM22.8022 18.6599L19.9349 19.9354L18.6593 22.8022L15.5399 22.4767L12.9997 24.3175L10.4595 22.4767L7.33946 22.8022L6.0639 19.9349L3.19714 18.6599L3.52266 15.5404L1.68186 12.9997L3.52318 10.4595L3.19766 7.33946L6.06494 6.0639L7.3405 3.19714L10.46 3.52266L12.9997 1.68186L15.5399 3.52266L18.6599 3.19714L19.9354 6.06442L22.8022 7.33946L22.4767 10.4589L24.3175 12.9997L22.4761 15.5399L22.8022 18.6599Z",
    fill: "#356966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9197 16.4245L7.64739 13.1521L6.91211 13.8874L10.9197 17.8951L20.1274 8.68743L19.3921 7.95215L10.9197 16.4245Z",
    fill: "#356966"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1867_103593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.140a4a67a1e8bbc00a871dc327bf0224.svg";
export { ForwardRef as ReactComponent };